import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BusinessAccount,
  BusinessAccountLimits,
  ServiceAccount,
  Employee,
  EmployeeRole,
  FinancialAccountListRequest,
  FinancialAccountListItem,
  FilterValues,
  FinancialAccountDetails,
  AccountBalancesRaw,
  Beneficiaries,
  Beneficiary,
} from '@shared/models';

export const BusinessAcccountActions = createActionGroup({
  source: 'Business Acccount Actions',
  events: {
    'Load Business Account Details': emptyProps,
    'Load Business Account Details Success': props<{ businessAccount: BusinessAccount | null }>(),
    'Load Business Account Details Failure': props<{ error: string }>(),
    'Load Business Account Limits': emptyProps,
    'Load Business Account Limits Success': props<{ businessAccountLimits: BusinessAccountLimits }>(),
    'Load Business Account Limits Failure': props<{ error: string }>(),
    'Set Limits Currency': props<{ currency: string }>(),
    'Load Business Account Balances Success': props<{ businessAccountBalances: AccountBalancesRaw }>(),
    'Load Business Account Balances Failure': props<{ error: string }>(),
    'Load Service Account Details': emptyProps,
    'Load Service Account Details Success': props<{ serviceAccount: ServiceAccount | null }>(),
    'Load Service Account Details Failure': props<{ error: string }>(),
    'Update Service Account Status': props<{ action: string }>(),
    'Update Service Account Status Failure': props<{ error: string; action: string }>(),
    'Delete Service Account': emptyProps,
    'Delete Service Account Success': emptyProps,
    'Delete Service Account Failure': props<{ error: string }>(),
    'Load Business Financial Accounts': props<{ params: FinancialAccountListRequest }>(),
    'Load Business Financial Accounts Success': props<{ financialAccounts: FinancialAccountListItem[]; totalElements: number }>(),
    'Load Business Financial Accounts Failure': props<{ error: string }>(),
    'Set Business Financial Accounts Active Filters': props<{ filters: FilterValues }>(),
    'Load Escrow Financial Account': emptyProps,
    'Load Escrow Financial Account Success': props<{ escrowFinancialAccount: FinancialAccountDetails | null }>(),
    'Load Escrow Financial Account Failure': props<{ error: string }>(),
    'Update Business Account State': props<{ state: string }>(),
    'Update Business Account State Failure': props<{ error: string; state: string }>(),
    'Load Beneficiaries': emptyProps,
    'Load Beneficiaries Success': props<{ beneficiaries: Beneficiaries[]; businessAccountId: string }>(),
    'Load Beneficiaries Failure': props<{ error: string }>(),
  },
});

export const EmployeeActions = createActionGroup({
  source: 'Employee Actions',
  events: {
    'Load Employee Details': emptyProps,
    'Load Employee Details Success': props<{ employeeDetails: Employee }>(),
    'Load Employee Details Failure': props<{ error: string }>(),
    'Update Employee Status': props<{ action: string }>(),
    'Update Employee Status Failure': props<{ error: string; action: string }>(),
    'Delete Employee': emptyProps,
    'Delete Employee Success': emptyProps,
    'Delete Employee Failure': props<{ error: string }>(),
    'Load Employee Roles': emptyProps,
    'Load Employee Roles Success': props<{ employeeRoles: EmployeeRole[] }>(),
    'Load Employee Roles Failure': props<{ error: string }>(),
  },
});

export const BeneficiaryActions = createActionGroup({
  source: 'Beneficiary Actions',
  events: {
    'Load Beneficiary Details': emptyProps,
    'Load Beneficiary Details Success': props<{ beneficiaryDetails: Beneficiary }>(),
    'Load Beneficiary Details Failure': props<{ error: string }>(),
    'Update Beneficiary Status': props<{ action: string }>(),
    'Update Beneficiary Status Failure': props<{ error: string; action: string }>(),
    'Delete Beneficiary': emptyProps,
    'Delete Beneficiary Success': emptyProps,
    'Delete Beneficiary Failure': props<{ error: string }>(),
  },
});
